import { createFileRoute } from "@tanstack/react-router";
import { m } from "#/paraglide/messages";
import { DeliveryDelayProcessPage } from "#/components/pages/delivery-delay-process/delivery-delay-process-page";

export const Route = createFileRoute(
  "/$tenantCode/$market/delivery-delay-process",
)({
  beforeLoad: () => ({
    getTitle: () => m["resources.deliveryDelayProcess.name"](),
  }),
  component: DeliveryDelayProcessPage,
});
